export class CmxAuthOAuth2 {
  access_token: string;
  expires_in: number;
  scope: string;
  refresh_token: string;
  region: string;
}

export class CmxAuthContact {
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  countryCode: string;
  ContactFunctionCode: string;
}

export class CmxAuthCustomer {
  customerId: number;
  customerDesc: string;
  userId: number;
  customerCode: string;
  contacts: CmxAuthContact[];
}

export class CmxAuthProfile {
  userId: number;
  customerId: number;
  status: string;
  userAccount: string;
  fullName: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  userType: string;
  accountType: string;
  userPosition: string;
  allowInformationShare: boolean;
  allowEmailUpdates: boolean;
  userSelectedId: string;
  isDigitalAdmin: boolean;
  hasTemporaryPassword: boolean;
  canChangePassword: boolean;
  languageId: number;
  cloudContactCode: string;
  customer?: CmxAuthCustomer;
}

export class CmxAuthRole {
  roleId: number;
  roleCode: string;
  roleName: string;
  roleDesc: string;
  roleType: string;
  isVisible: boolean;
}

export class CmxAuthApplication {
  applicationId: number;
  applicationName: string;
  applicationCode: string;
  applicationDesc: string;
  isVisible: boolean;
  roles: CmxAuthRole[];
}

export class CmxAuth {
  oauth2: CmxAuthOAuth2;
  jwt: string;
  powerUser: string;
  edit: string;
  customerId: number;
  sessionId: number;
  role: string;
  country: string;
  customer: CmxAuthCustomer;
  profile: CmxAuthProfile;
  applications: CmxAuthApplication[];
}
